"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownNestedMenu", {
    enumerable: true,
    get: function() {
        return DropdownNestedMenu;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _ri = require("react-icons/ri");
const _bs = require("react-icons/bs");
const _NavItem = require("../../NavItem/NavItem");
const _Dropdown = require("../Dropdown");
const _DropdownMenu = require("../DropdownMenu/DropdownMenu");
const _NavContext = require("../../../contexts/NavContext");
const _contexts = require("../../../contexts");
const _useHtmlId = require("../../../hooks/useHtmlId");
const _useIsMobileWidth = require("../../../hooks/useIsMobileWidth");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const DropdownNestedNavItem = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { children, isMobile, title, disabled = false, ...props } = param;
    // nested dropdown context
    const { show, placement, setToggleId, setShow, reference, refs } = (0, _react.useContext)(_Dropdown.DropdownContext);
    const { isAdmin } = (0, _contexts.useTheme)();
    const RightIcon = isAdmin ? _ri.RiArrowRightSLine : _bs.BsChevronRight;
    const id = (0, _useHtmlId.useHtmlId)();
    (0, _react.useEffect)(()=>setToggleId(id), [
        id,
        setToggleId
    ]);
    const currentRef = refs.reference.current instanceof HTMLElement && refs.reference.current.id === id ? refs.reference.current : null;
    const floatingRef = refs.floating.current;
    (0, _react.useImperativeHandle)(ref, ()=>({
            click: ()=>currentRef === null || currentRef === void 0 ? void 0 : currentRef.click(),
            focus: ()=>currentRef === null || currentRef === void 0 ? void 0 : currentRef.focus()
        }));
    const [itemHasFocus, setItemHasFocus] = (0, _react.useState)(false);
    const [nestedItemHasFocus, setNestedItemHasFocus] = (0, _react.useState)(false);
    // track if focus is inside the nested menu
    // note that unlike `focus`/`blur`, `focusin`/`focusout` events bubble
    (0, _react.useEffect)(()=>{
        const isInsideNestedMenu = (target)=>target instanceof HTMLElement && floatingRef instanceof HTMLElement && floatingRef.contains(target);
        const onFocusIn = (e)=>{
            if (isInsideNestedMenu(e.target)) {
                setNestedItemHasFocus(true);
            }
        };
        const onFocusOut = (e)=>{
            if (isInsideNestedMenu(e.target)) {
                setNestedItemHasFocus(false);
            }
        };
        floatingRef === null || floatingRef === void 0 ? void 0 : floatingRef.addEventListener("focusin", onFocusIn);
        floatingRef === null || floatingRef === void 0 ? void 0 : floatingRef.addEventListener("focusout", onFocusOut);
        return ()=>{
            floatingRef === null || floatingRef === void 0 ? void 0 : floatingRef.removeEventListener("focusin", onFocusIn);
            floatingRef === null || floatingRef === void 0 ? void 0 : floatingRef.removeEventListener("focusout", onFocusOut);
        };
    }, [
        floatingRef
    ]);
    // close the nested menu when focus moves fully off this item and its nested
    // menu
    (0, _react.useEffect)(()=>{
        if (!isMobile && show && !itemHasFocus && !nestedItemHasFocus) {
            // It seems like focus has left this item entirely, but the `focusin`
            // arrives *after* this effect initially gets triggered.
            // Wait a little while to see if a submenu item gets focused before we
            // close the submenu.
            const timeout = setTimeout(()=>setShow(false));
            return ()=>clearTimeout(timeout);
        }
        return ()=>undefined;
    }, [
        isMobile,
        show,
        itemHasFocus,
        nestedItemHasFocus,
        setShow
    ]);
    return /*#__PURE__*/ _react.default.createElement(_NavItem.NavItem, {
        ...props,
        ref: reference,
        id: id,
        title: title,
        rightIcon: isMobile ? RightIcon : undefined,
        disabled: disabled,
        nestedMenu: children,
        nestedMenuPlacement: placement,
        nestedItemHasFocus: nestedItemHasFocus,
        "aria-expanded": show ? "true" : "false",
        onClick: (e)=>{
            var _props_onClick;
            if (!disabled) {
                setShow(true);
            }
            (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e);
        },
        onMouseEnter: (e)=>{
            var _props_onMouseEnter;
            if (!disabled && !isMobile) {
                setShow(true);
                setItemHasFocus(true);
            }
            (_props_onMouseEnter = props.onMouseEnter) === null || _props_onMouseEnter === void 0 ? void 0 : _props_onMouseEnter.call(props, e);
        },
        onMouseLeave: (e)=>{
            var _props_onMouseLeave;
            if (!isMobile) {
                setShow(false);
                setItemHasFocus(false);
            }
            (_props_onMouseLeave = props.onMouseLeave) === null || _props_onMouseLeave === void 0 ? void 0 : _props_onMouseLeave.call(props, e);
        },
        onKeyDown: (e)=>{
            var _props_onKeyDown;
            if (e.key === "Enter" && !disabled && e.target === e.currentTarget) {
                setShow(!show);
            }
            (_props_onKeyDown = props.onKeyDown) === null || _props_onKeyDown === void 0 ? void 0 : _props_onKeyDown.call(props, e);
        },
        onFocus: (e)=>{
            var _props_onBlur;
            setItemHasFocus(true);
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
        },
        onBlur: (e)=>{
            var _props_onBlur;
            setItemHasFocus(false);
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
        }
    }, title);
});
DropdownNestedNavItem.displayName = "DropdownNestedNavItem";
const DropdownNestedMenu = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { children, title, placement = "right-start", mobileView, autoClose = true, maxHeight, onSelect, ...itemProps } = param;
    // parent dropdown context
    const { onSelect: parentOnSelect, autoClose: triggerAutoClose } = (0, _react.useContext)(_Dropdown.DropdownContext);
    const { fontWeight } = (0, _react.useContext)(_NavContext.NavContext);
    const isMobileWidth = (0, _useIsMobileWidth.useIsMobileWidth)();
    const isMobile = isMobileWidth && mobileView != null;
    return /*#__PURE__*/ _react.default.createElement(_Dropdown.Dropdown, {
        fontWeight: fontWeight,
        placement: placement,
        offset: 4,
        onSelect: onSelect !== null && onSelect !== void 0 ? onSelect : parentOnSelect,
        onAutoClose: autoClose ? triggerAutoClose : undefined,
        flip: true
    }, /*#__PURE__*/ _react.default.createElement(DropdownNestedNavItem, {
        ...itemProps,
        ref: ref,
        title: title,
        isMobile: isMobile
    }, /*#__PURE__*/ _react.default.createElement(_DropdownMenu.DropdownMenu, {
        isNested: true,
        mobileView: mobileView,
        title: title,
        maxHeight: maxHeight
    }, children)));
});
DropdownNestedMenu.displayName = "DropdownNestedMenu";

//# sourceMappingURL=DropdownNestedMenu.js.map